import i18next from 'i18next'
import {Updater} from 'widgets-for-react'
import {
  buildValidator,
  isValidatorPassed,
  Validator,
  validatorBuilders,
  ValidatorResult,
  validatorResultBuilders,
} from '../../validator/validator'

export type CompanyType = { Title: string | undefined }
export const emptyCompanyType: CompanyType = {Title: ''}

const companyTypeValidator = buildValidator<CompanyType>({
  Title: [
    (b) => b.notEmpty(),
    validatorBuilders.string('Title', () =>
      i18next.t(`subscriptionValidators:CompanyType`)
    ),
  ],
})

export type CompanyTypeSelectorState = {
  input: CompanyType
  validator: Validator<CompanyType, CompanyType>
  validatorResult: ValidatorResult
  isValid(): boolean
}

export const initialCompanyTypeSelectorState = (companyType: CompanyType): CompanyTypeSelectorState => {
  let initialCompanyType = emptyCompanyType
  if (companyType) {
    initialCompanyType.Title = companyType.Title
  }
  return {
    input: initialCompanyType,
    validator: companyTypeValidator.setValueToValidate(initialCompanyType, initialCompanyType),
    validatorResult: validatorResultBuilders.validating(''),
    isValid: function (this: CompanyTypeSelectorState) {
      return isValidatorPassed(this.validatorResult)
    },
  }
}

export const companyTypeSelectorStateUpdaters = {
  input:
    (u: Updater<CompanyTypeSelectorState['input']>): Updater<CompanyTypeSelectorState> =>
    (s) => {
      const newInput = u(s.input)
      return {
        ...s,
        input: newInput,
        validator: s.validator.setValueToValidate(newInput, newInput),
      }
    },
  validation:
    (u: Updater<CompanyTypeSelectorState['validator']>): Updater<CompanyTypeSelectorState> =>
    (s) => {
      const newValidator = u(s.validator)
      return {
        ...s,
        validator: newValidator,
        validatorResult: newValidator.evaluateResult(),
      }
    },
}
